export default "<p>loaders works!</p>\r\n"